import React, { useState } from 'react';
import ReddyLayout from '../components/home/ReddyLayout';
import MatchHeader from '../components/match/MatchHeader';
import MarketSection from '../components/match/MarketSection';
import MarqueeBar from '../components/match/MarqueeBar';
import FancySection from '../components/match/FancySection';
import LastDigitMarket from '../components/match/LastDigitMarket';
import ScoreCard from '../components/match/ScoreCard';
import BetSlip from '../components/match/BetSlip';
import { MATCH } from '../data/matchData';

const stop = (e) => e.preventDefault();

export default function MatchPage() {
  /* a clicked back/lay odds cell fills the bet slip; null → empty panel */
  const [bet, setBet] = useState(null);
  const [scOpen, setScOpen] = useState(true); // live scorecard collapse
  return (
    <ReddyLayout>
      <section className="section listing_page">
        <div className="row">
          <div className="col-md-12 col-lg-8 detail-center-column">
            {/* Golden Kick promo strip (above the content card) */}
            <a className="detail-casino-link" href="#!" onClick={stop}>
              <i className="bi bi-hand-index-thumb-fill" /> Golden Kick
            </a>
            <div className="middle-page-content details-page">
              <MatchHeader match={MATCH} scorecardOpen={scOpen} onToggleScorecard={() => setScOpen((o) => !o)} />
              <ScoreCard scorecard={MATCH.scorecard} open={scOpen} />
              {MATCH.markets.map((m, i) => (
                <React.Fragment key={m.id}>
                  <MarketSection market={m} onSelectBet={setBet} />
                  {i === 0 && <MarqueeBar text={MATCH.marquee} />}
                </React.Fragment>
              ))}
              {/* mobile-only inline bet slip — flows in right under MATCH ODDS / Bookmaker when a
                  cell is tapped (rendered only when `bet` is set → no empty box). Hidden ≥992px,
                  where the right-column slip below shows instead. Both share the same `bet` state. */}
              {bet && (
                <div className="d-lg-none">
                  <BetSlip bet={bet} onClose={() => setBet(null)} />
                </div>
              )}
              <FancySection fancy={MATCH.fancy} onSelectBet={setBet} />
              <LastDigitMarket market={MATCH.lastDigit} onSelectBet={setBet} />
            </div>
          </div>
          <div className="col-lg-4 d-none d-lg-block">
            <BetSlip bet={bet} onClose={() => setBet(null)} />
          </div>
        </div>
      </section>
    </ReddyLayout>
  );
}
